import Berries from "./Berries";

export default Berries;